type CapacityGranularity = "WEEK" | "MONTH";

const capacityGranularity: CapacityGranularity = "MONTH";

export type { CapacityGranularity };

export { capacityGranularity };
